unit Essentials.Web.Lookup.EditLookupValueForm;

interface

uses
  System.SysUtils, System.Variants, System.Classes, Vcl.Graphics,
  Vcl.Controls, Vcl.Forms, Vcl.Dialogs, Essentials.Web.BaseEditForm, Data.DB,
  WEBLib.DB, Vcl.StdCtrls, WEBLib.StdCtrls, WEBLib.DBCtrls, Essentials.Web.Shared;

type
  TEditLookupValue = class(TEssentialsBaseEditForm)
    LookupDescriptionEdit: TDBEdit;
    LookupSortOrderEdit: TDBEdit;
    LookupValueEdit: TDBEdit;
    procedure WebFormCreate(Sender: TObject);
    procedure LookupValueEditExit(Sender: TObject);
  private
    { Private declarations }
    procedure SetEditMode(const Value: TEditMode); override;
  protected
    function AllRequiredFieldsAreSet: Boolean; override;
  public
    { Public declarations }
  protected procedure LoadDFMValues; override; end;

var
  EditLookupValue: TEditLookupValue;

implementation

{$R *.dfm}

function TEditLookupValue.AllRequiredFieldsAreSet: Boolean;
begin
  Result := LookupValueEdit.Text <> '';
end;

procedure TEditLookupValue.LookupValueEditExit(Sender: TObject);
begin
  inherited;
  UpdateState;
end;

procedure TEditLookupValue.SetEditMode(const Value: TEditMode);
begin
  inherited;
  if FEditMode <> None then
  begin
    LookupValueEdit.Enabled := FEditMode = Add;
    LookupDescriptionEdit.Enabled := True;
    LookupSortOrderEdit.Enabled := True;
    LookupValueEdit.SetFocus;
  end;
end;

procedure TEditLookupValue.WebFormCreate(Sender: TObject);
begin
  inherited;
  LookupValueEdit.Enabled := False;
  LookupDescriptionEdit.Enabled := False;
  LookupSortOrderEdit.Enabled := False;
end;

procedure TEditLookupValue.LoadDFMValues;
begin
  inherited LoadDFMValues;

  LookupDescriptionEdit := TDBEdit.Create('essentials.lookup.description.edit');
  LookupSortOrderEdit := TDBEdit.Create('essentials.lookup.sortorder.edit');
  LookupValueEdit := TDBEdit.Create('essentials.lookup.value.edit');

  TitleBarLabel.BeforeLoadDFMValues;
  LookupDescriptionEdit.BeforeLoadDFMValues;
  LookupSortOrderEdit.BeforeLoadDFMValues;
  LookupValueEdit.BeforeLoadDFMValues;
  try
    Height := 182;
    Caption := 'EditLookupValue';
    SetEvent(Self, 'OnCreate', 'WebFormCreate');
    TitleBarLabel.Width := 94;
    TitleBarLabel.Caption := 'Edit Lookup Value';
    LookupDescriptionEdit.SetParentComponent(Self);
    LookupDescriptionEdit.Name := 'LookupDescriptionEdit';
    LookupDescriptionEdit.Left := 335;
    LookupDescriptionEdit.Top := 120;
    LookupDescriptionEdit.Width := 242;
    LookupDescriptionEdit.Height := 22;
    LookupDescriptionEdit.ChildOrder := 4;
    LookupDescriptionEdit.ElementClassName := 'form-control';
    LookupDescriptionEdit.ElementFont := efCSS;
    LookupDescriptionEdit.ElementPosition := epIgnore;
    LookupDescriptionEdit.HeightStyle := ssAuto;
    LookupDescriptionEdit.HeightPercent := 100.000000000000000000;
    LookupDescriptionEdit.Text := 'LookupDescriptionEdit';
    LookupDescriptionEdit.WidthStyle := ssAuto;
    LookupDescriptionEdit.WidthPercent := 100.000000000000000000;
    LookupDescriptionEdit.DataField := 'Description';
    LookupDescriptionEdit.DataSource := DataSource;
    LookupSortOrderEdit.SetParentComponent(Self);
    LookupSortOrderEdit.Name := 'LookupSortOrderEdit';
    LookupSortOrderEdit.Left := 208;
    LookupSortOrderEdit.Top := 120;
    LookupSortOrderEdit.Width := 121;
    LookupSortOrderEdit.Height := 22;
    LookupSortOrderEdit.ChildOrder := 6;
    LookupSortOrderEdit.EditType := weNumeric;
    LookupSortOrderEdit.ElementClassName := 'form-control';
    LookupSortOrderEdit.ElementFont := efCSS;
    LookupSortOrderEdit.ElementPosition := epIgnore;
    LookupSortOrderEdit.HeightStyle := ssAuto;
    LookupSortOrderEdit.HeightPercent := 100.000000000000000000;
    LookupSortOrderEdit.Text := 'LookupSortOrderEdit';
    LookupSortOrderEdit.WidthStyle := ssAuto;
    LookupSortOrderEdit.WidthPercent := 100.000000000000000000;
    LookupSortOrderEdit.DataField := 'SortOrder';
    LookupSortOrderEdit.DataSource := DataSource;
    LookupValueEdit.SetParentComponent(Self);
    LookupValueEdit.Name := 'LookupValueEdit';
    LookupValueEdit.Left := 31;
    LookupValueEdit.Top := 120;
    LookupValueEdit.Width := 171;
    LookupValueEdit.Height := 22;
    LookupValueEdit.ChildOrder := 4;
    LookupValueEdit.ElementClassName := 'form-control';
    LookupValueEdit.ElementFont := efCSS;
    LookupValueEdit.ElementPosition := epIgnore;
    LookupValueEdit.HeightStyle := ssAuto;
    LookupValueEdit.HeightPercent := 100.000000000000000000;
    LookupValueEdit.Text := 'LookupValueEdit';
    LookupValueEdit.WidthStyle := ssAuto;
    LookupValueEdit.WidthPercent := 100.000000000000000000;
    SetEvent(LookupValueEdit, Self, 'OnExit', 'LookupValueEditExit');
    LookupValueEdit.DataField := 'LookUpValue';
    LookupValueEdit.DataSource := DataSource;
  finally
    TitleBarLabel.AfterLoadDFMValues;
    LookupDescriptionEdit.AfterLoadDFMValues;
    LookupSortOrderEdit.AfterLoadDFMValues;
    LookupValueEdit.AfterLoadDFMValues;
  end;
end;

end.
